import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
    selector: '[inputText]',
    standalone: false
})
export class InputTextDirective {

  regexStr      = '^[ A-Za-z0-9_.,/#&-]*$';
  regexOnlyChar = '^[ A-Za-z0-9_./#&-]*$';

  constructor(private el: ElementRef) { }

  @HostListener('keypress', ['$event']) onKeyPress(event: KeyboardEvent) {
    if (this.el.nativeElement.value === '') {
      return new RegExp(this.regexOnlyChar).test(event.key);
    } else {
      return new RegExp(this.regexStr).test(event.key);
    }
  }

  @HostListener('paste', ['$event']) blockPaste() {
    this.validateFields();
  }

  validateFields() {
    this.el.nativeElement.value = this.el.nativeElement.value.replace(/[^A-Za-z0-9À-ÖØ-öø-ÿ_.,/#& ]+/g, '').replace(/[ ]*$/g, '');
  }

}
